module.exports = __webpack_public_path__ + "img/guessFa.328a07e7.svg";